import { useQuery } from "react-query";
import { getMedia } from "../api";
import { useToken } from "./useToken";

export const useMedia = (page) => {
  const { token } = useToken();
  return useQuery(["getMedia", page], () => getMedia({ token, page }));
};
